import { render, staticRenderFns } from "./dropdown-item.html?vue&type=template&id=2d7d2b5e&scoped=true&"
import script from "./dropdown-item.js?vue&type=script&lang=js&"
export * from "./dropdown-item.js?vue&type=script&lang=js&"
import style0 from "./dropdown-item.scss?vue&type=style&index=0&id=2d7d2b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7d2b5e",
  null
  
)

export default component.exports